import { RouteObject } from "react-router-dom";
import { NotFound } from "../../../commons/components";
import AuthGuardWrapper from "../../auth/AuthGuardWrapper";
import { ManageFootballTeam } from "../../../commons/models/football/admin/manage-football-team";
import SubTeamDetailManage from "./SubTeamDetailManage";
import SubTeamManageSquad from "./SubTeamManageSquad";
import SubTeamManageProfile from "./SubTeamManageProfile";
import TeamManageEvents from "../teams/TeamManageEvents";
import TeamManageStatistics from "../teams/TeamManageStatistics";
import TeamManageStanding from "../teams/TeamManageStanding";

const SUB_TEAM_PROFILE = "profile";
const SUB_TEAM_SQUAD = "squad";
const SUB_TEAM_EVENTS = "events";
const SUB_TEAM_STATISTICS = "statistics";
const SUB_TEAM_STANDING = "standings";

export const routerAdminSubTeam: RouteObject[] = [
  {
    path: "",
    element: (
      <AuthGuardWrapper subject={ManageFootballTeam}>
        <SubTeamDetailManage />
      </AuthGuardWrapper>
    ),
    children: [
      { index: true, element: <SubTeamManageProfile /> },
      { path: SUB_TEAM_PROFILE, element: <SubTeamManageProfile /> },
      { path: SUB_TEAM_SQUAD, element: <SubTeamManageSquad /> },
      { path: SUB_TEAM_EVENTS, element: <TeamManageEvents /> },
      { path: SUB_TEAM_STATISTICS, element: <TeamManageStatistics /> },
      { path: SUB_TEAM_STANDING, element: <TeamManageStanding /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];
